import React from 'react';
import { Link } from 'gatsby';
import { SimpleLink } from './SimpleLink';
import { trackEvent, TrackingEvents } from 'helpers/TrackingHelper';

type FeatureBoxProps = {
    title: string;
    paragraph: string;
    link: string;
    icon: any;
    hoverIcon: any;
    linkText?: string;
};

export const FeatureBox = ({
    icon,
    hoverIcon,
    link,
    paragraph,
    title,
    linkText
}: FeatureBoxProps) => {
    return (
        <Link
            to={link}
            className="tw-relative tw-group"
            onClick={() => trackEvent(TrackingEvents.CLICK_USE_CASE, { click_source: title })}
        >
            <div className="tw-absolute -tw-top-32 -tw-right-24 tw-bg-neutral tw-h-64 tw-w-64 tw-z-10">
                <div className="group-hover:tw-hidden tw-inline-block">{icon}</div>
                <div className="group-hover:tw-inline-block tw-hidden">{hoverIcon}</div>
            </div>
            <div className="tw-relative active:tw-drop-shadow-none hover:tw-drop-shadow-lg tw-border tw-py-24 tw-px-32 tw-prose tw-max-w-none tw-rounded tw-w-full tw-bg-neutral tw-h-full tw-transition-all">
                <div className="tw-flex tw-flex-col tw-justify-between tw-h-full">
                    <div>
                        <h2 className="tw-m-0 tw-mb-8 tw-text-primary group-hover:tw-text-primaryRed-hover tw-transition-colors bold">
                            {title}
                        </h2>
                        <p className="tw-m-0">{paragraph}</p>
                    </div>
                    <SimpleLink
                        onlyVisual={true}
                        arrowMainColor="#000000"
                        arrowSecondaryColor="#DC5171"
                        className="tw-mt-24"
                        size="small"
                    >
                        {linkText ? linkText : 'Learn more'}
                    </SimpleLink>
                </div>
            </div>
        </Link>
    );
};
